
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.5 0h-9a2.064 2.064 0 00-2.063 2.063v13.874A2.064 2.064 0 004.5 18h9a2.064 2.064 0 002.063-2.063V2.063A2.064 2.064 0 0013.5 0zM9 7.125a3 3 0 013 3v1.125a.75.75 0 01-.75.75h-.582a.188.188 0 00-.187.166l-.281 2.541a.75.75 0 01-.745.668H8.55a.75.75 0 01-.746-.668l-.282-2.54a.187.187 0 00-.19-.167H6.75a.75.75 0 01-.75-.75v-1.125a3 3 0 013-3zM7.125 4.5a1.875 1.875 0 113.75 0 1.875 1.875 0 01-3.75 0z","fill":"currentColor"}})])
          )
        }
      }
    